<template>
  <base-template current-page="AccountIndex">
    <router-view></router-view>
  </base-template>
</template>

<script>
import BaseTemplate from "../BaseTemplate";

export default {
  name: "AccountIndex",
  components: { BaseTemplate },
};
</script>
